import { Box, Flex, Icon } from "@chakra-ui/react";
import { HiStar } from "react-icons/hi";

import Swipeable from "components/Swipeable";
import { OFText } from "design_system/components/OFText";

type Review = {
  content: string;
  name: string;
  stars: number;
};

type Props = {
  reviews: Review[];
};
export const Testimonials = ({ reviews }: Props) => {
  return (
    <Swipeable showPercent={false} showSlider isAuto maxW="100vw">
      {reviews.map((review) => (
        <Flex direction="column" alignItems="center" key={review.name}>
          <Flex align="center" mb={4}>
            {Array.from({ length: 5 }, (_, i) => i).map((number) => (
              <Icon key={number} as={HiStar} color="evalStar" fontSize="xl" />
            ))}
          </Flex>

          <Box maxW={["80%", "4xl"]}>
            <OFText textStyle="body2" align="center" mb={4}>
              {review.content}
            </OFText>
          </Box>

          <OFText textStyle="subhead1" letterSpacing="wider">
            {review.name.toUpperCase()}
          </OFText>
        </Flex>
      ))}
    </Swipeable>
  );
};
